/*
* Association construction information form view for authenticated users
*/

import * as _ from 'lodash';
import * as React from 'react';

import * as KendoWrappers from '../../common/kendoforms/componentwrappers';
import * as DetailFormCommon from './common';

export const AssociationDetailsConstructionInformation = ({
    appText,
    handleFormInputChange,    
    handleSubmitForm,
    handleSaveChanges,
    numFormChanges,    
    formData,
    defaultInputProps,
    sectionTitle,
    ...rest }) => {
    if (!appText || !formData) { return (<div />); }

    let inputPropsFullWidthTextDebounced = _.merge({}, defaultInputProps, {
        handleChange: (n, v) => { handleFormInputChange(n, v); },
        className: 'inventory-detail-input-75',
        colLabelXs: 5,
        colInputXs: 7,
    });

    let inputPropsFullWidthTextAreaDebounced = _.merge({}, defaultInputProps, {
        handleChange: (n, v) => { handleFormInputChange(n, v); },
        className: 'inventory-detail-input-full-width',
        colLabelXs: 12,
        colInputXs: 12,
    });

    let inputProps = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChange(n, v); },
        colLabelXs: 5,
        colInputXs: 7,
    });

    return (
        <DetailFormCommon.AssociationDetailFormSection title={sectionTitle}>
            <div>               
                <div>
                    <KendoWrappers.KendoNumberInput
                        name="details.numberUnits"
                        label={appText('number-of-units')}
                        value={formData.details.numberUnits}
                        {...inputProps}
                    />
                </div>

                <div>
                    <KendoWrappers.KendoNumberInput
                        name="details.numberBuildings"
                        label={appText('number-of-buildings')}
                        value={formData.details.numberBuildings}
                        {...inputProps}
                    />
                </div>

                <div>
                    <KendoWrappers.KendoNumberInput
                        name="details.numberStories"
                        label={appText('number-of-stories')}
                        value={formData.details.numberStories}
                        {...inputProps}
                    />
                </div>

                <div>
                    <KendoWrappers.KendoTextInputDebounced
                        name="details.phases"
                        label={appText('phases')}
                        value={formData.details.phases}
                        {...inputPropsFullWidthTextDebounced}
                    />
                </div>

                <div>
                    <KendoWrappers.KendoTextInputDebounced
                        name="details.fiscalYearEnd"
                        label={appText('fiscal-year-end')}
                        value={formData.details.fiscalYearEnd}
                        {...inputPropsFullWidthTextDebounced}
                    />
                </div>

                <div>
                    <KendoWrappers.KendoTextInputDebounced
                        name="details.constructDate"
                        label={appText('construction-date')}
                        value={formData.details.constructDate}
                        {...inputPropsFullWidthTextDebounced}
                    />
                </div>

                <div>
                    <KendoWrappers.KendoTextInputDebounced
                        name="details.converDate"
                        label={appText('conversion-date')}
                        value={formData.details.converDate}
                        {...inputPropsFullWidthTextDebounced}
                    />
                </div>

                <div>
                    <KendoWrappers.KendoTextareaDebounced
                        name="details.executiveSummaryDetails"
                        label={appText('executive-summary-details')}
                        value={formData.details.executiveSummaryDetails}
                        {...inputPropsFullWidthTextAreaDebounced}
                    />
                </div>
            </div>
        </DetailFormCommon.AssociationDetailFormSection>
    );
};



// WEBPACK FOOTER //
// ./src/association/detail-form/association-details-construction-information.tsx